import { Shield, Users, Zap } from 'lucide-react';
import styles from './HeroFeatureList.module.css';

interface FeatureItem {
  icon: typeof Zap;
  iconBgClass?: string | undefined;
  iconColorClass?: string | undefined;
  title: string;
  description: string;
}

const features: FeatureItem[] = [
  {
    icon: Zap,
    iconBgClass: styles.zapBg,
    iconColorClass: styles.zapColor,
    title: 'Increase productivity',
    description: 'Automate repetitive tasks',
  },
  {
    icon: Users,
    iconBgClass: styles.usersBg,
    iconColorClass: styles.usersColor,
    title: 'Better collaboration',
    description: 'Keep your team aligned',
  },
  {
    icon: Shield,
    iconBgClass: styles.shieldBg,
    iconColorClass: styles.shieldColor,
    title: 'Enterprise security',
    description: 'Your data, always protected',
  },
];

export function HeroFeatureList() {
  return (
    <div className={styles.container}>
      {features.map((feature) => {
        const IconComponent = feature.icon;
        return (
          <div key={feature.title} className={styles.item}>
            <div className={`${styles.iconBadge ?? ''} ${feature.iconBgClass ?? ''}`}>
              <IconComponent size={18} className={feature.iconColorClass ?? ''} strokeWidth={2.2} />
            </div>
            <div className={styles.textContent}>
              <h4 className={styles.itemTitle}>{feature.title}</h4>
              <p className={styles.itemDescription}>{feature.description}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
